//src/services/surveyRiskSuggestions.ts
import { api } from "@/lib/apiClient";
import type {
  SurveyRiskSuggestionApproveIn,
  SurveyRiskSuggestionConvertIn,
  SurveyRiskSuggestionDecisionOut,
  SurveyRiskSuggestionDetail,
  SurveyRiskSuggestionLog,
  SurveyRiskSuggestionPage,
  SurveyRiskSuggestionRejectIn,
  SurveyRiskSuggestionResetIn,
  SurveyRiskSuggestionSummary,
} from "@/types/surveyRiskSuggestions";

export async function listSurveyRiskSuggestionsQueue(params?: {
  campaign_id?: string;
  status?: string;
  cut_type?: string;
  risk_level_code?: string;
  page?: number;
  per_page?: number;
}) {
  return api.get<SurveyRiskSuggestionPage>("/survey-risk-suggestions", {
    params: {
      campaign_id: params?.campaign_id || undefined,
      status: params?.status || undefined,
      cut_type: params?.cut_type || undefined,
      risk_level_code: params?.risk_level_code || undefined,
      page: params?.page || undefined,
      per_page: params?.per_page || undefined,
    },
  });
}

export async function getSurveyRiskSuggestionsSummary(params?: {
  campaign_id?: string;
  status?: string;
  cut_type?: string;
  risk_level_code?: string;
}) {
  return api.get<SurveyRiskSuggestionSummary>("/survey-risk-suggestions/summary", {
    params: {
      campaign_id: params?.campaign_id || undefined,
      status: params?.status || undefined,
      cut_type: params?.cut_type || undefined,
      risk_level_code: params?.risk_level_code || undefined,
    },
  });
}

export async function getSurveyRiskSuggestionDetail(suggestionId: string) {
  return api.get<SurveyRiskSuggestionDetail>(`/survey-risk-suggestions/${suggestionId}`);
}

export async function listSurveyRiskSuggestionLogs(suggestionId: string) {
  return api.get<SurveyRiskSuggestionLog[]>(`/survey-risk-suggestions/${suggestionId}/logs`);
}

export async function approveSurveyRiskSuggestion(suggestionId: string, payload: SurveyRiskSuggestionApproveIn) {
  return api.post<SurveyRiskSuggestionDecisionOut>(`/survey-risk-suggestions/${suggestionId}/approve`, payload);
}

export async function rejectSurveyRiskSuggestion(suggestionId: string, payload: SurveyRiskSuggestionRejectIn) {
  return api.post<SurveyRiskSuggestionDecisionOut>(`/survey-risk-suggestions/${suggestionId}/reject`, payload);
}

export async function resetSurveyRiskSuggestion(suggestionId: string, payload?: SurveyRiskSuggestionResetIn) {
  return api.post<SurveyRiskSuggestionDecisionOut>(`/survey-risk-suggestions/${suggestionId}/reset`, payload || {});
}

export async function convertSurveyRiskSuggestion(suggestionId: string, payload?: SurveyRiskSuggestionConvertIn) {
  return api.post<SurveyRiskSuggestionDecisionOut>(`/survey-risk-suggestions/${suggestionId}/convert`, payload || {});
}

export async function approveAndConvertSurveyRiskSuggestion(suggestionId: string, payload?: SurveyRiskSuggestionConvertIn) {
  return api.post<SurveyRiskSuggestionDecisionOut>(`/survey-risk-suggestions/${suggestionId}/approve-and-convert`, payload || {});
}
